<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      :title="title"
      center
      width="700px"
      :before-close="$onClose"
      destroy-on-close
    >
      <div style="margin: 30px 100px 30px 20px; background-color: transparent">
        <div v-if="showUnit1">
          <h4 class="title">{{ title_1 }}</h4>
          <el-select class="input" v-model="input_1" placeholder="请选择">
            <el-option
              v-for="item in options1"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="showUnit2">
          <h4 class="title">{{ title_2 }}</h4>
          <el-select class="input" v-model="input_2" placeholder="请选择">
            <el-option
              v-for="item in options2"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="showUnit3">
          <h4 class="title">{{ title_3 }}</h4>
          <el-select class="input" v-model="input_3" placeholder="请选择">
            <el-option
              v-for="item in options3"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="showUnit4">
          <h4 class="title">{{ title_4 }}</h4>
          <el-select class="input" v-model="input_4" placeholder="请选择">
            <el-option
              v-for="item in options4"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="showUnit5">
          <h4 class="title">{{ title_5 }}</h4>
          <el-select class="input" v-model="input_5" placeholder="请选择">
            <el-option
              v-for="item in options5"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="showUnit6">
          <h4 class="title">{{ title_6 }}</h4>
          <el-select class="input" v-model="input_6" placeholder="请选择">
            <el-option
              v-for="item in options6"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="showUnit7">
          <h4 class="title">{{ title_7 }}</h4>
          <el-select class="input" v-model="input_7" placeholder="请选择">
            <el-option
              v-for="item in options7"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="showUnit8">
          <h4 class="title">{{ title_8 }}</h4>
          <el-select class="input" v-model="input_8" placeholder="请选择">
            <el-option
              v-for="item in options8"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="showUnit9">
          <h4 class="title">{{ title_9 }}</h4>
          <el-select class="input" v-model="input_9" placeholder="请选择">
            <el-option
              v-for="item in options9"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="showUnit10">
          <h4 class="title">{{ title_10 }}</h4>
          <el-select class="input" v-model="input_10" placeholder="请选择">
            <el-option
              v-for="item in options10"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div v-if="showUnit11">
          <h4 class="title">{{ title_11 }}</h4>
          <el-select class="input" v-model="input_11" placeholder="请选择">
            <el-option
              v-for="item in options11"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <!-- <div id="unit2" v-if="showUnit2">
          <h4 class="title">{{title_2}}</h4>
          <el-input v-model="input_2" placeholder="请输入"></el-input>
        </div>
        <div id="unit3" v-if="showUnit3">
          <h4 class="title">{{title_3}}</h4>
          <el-input v-model="input_3" placeholder="请输入"></el-input>
        </div>
        <div id="unit4" v-if="showUnit4">
          <h4 class="title">{{title_4}}</h4>
          <el-input v-model="input_4" placeholder="请输入"></el-input>
        </div>
        <div id="unit5" v-if="showUnit5">
          <h4 class="title">{{title_5}}</h4>
          <el-input v-if="showInput5" v-model="input_5" placeholder="请输入"></el-input>
          <el-date-picker
            v-if="!showInput5"
            id="v_date_5"
            v-model="input_5"
            type="year"
            placeholder="选择年"
            value-format="yyyy"
          ></el-date-picker>
        </div>
        <div id="unit6" v-if="showUnit6">
          <h4 class="title">{{title_6}}</h4>
          <el-input v-model="input_6" placeholder="请输入"></el-input>
        </div>
        <div id="unit7" v-if="showUnit7">
          <h4 class="title">{{title_7}}</h4>
          <el-input v-model="input_7" placeholder="请输入"></el-input>
        </div>-->
      </div>

      <p>*系统已合并完全相同的字段</p>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right"
          size="small"
          type="primary"
          @click="save()"
          >保存</el-button
        >
        <el-button
          style="width: 106px; float: right; margin-right: 15px"
          size="small"
          @click="close()"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import { isEmpty } from "@/utils/strUtils";

var showFlag;

export default {
  data() {
    return {
      changVisible: false,
      showUnit1: true,
      showUnit2: true,
      showUnit3: true,
      showUnit4: true,
      showUnit5: true,
      showUnit6: true,
      showUnit7: true,
      showUnit8: true,
      showUnit9: true,
      showUnit10: true,
      showUnit11: true,
      title: "选择冲突数据",
      title_1: "",
      title_2: "",
      title_3: "",
      title_4: "",
      title_5: "",
      title_6: "",
      title_7: "",
      title_8: "",
      title_9: "",
      title_10: "",
      title_11: "",

      input_1: "",
      input_2: "",
      input_3: "",
      input_4: "",
      input_5: "",
      input_6: "",
      input_7: "",
      input_8: "",
      input_9: "",
      input_10: "",
      input_11: "",

      options1: [],
      options2: [],
      options3: [],
      options4: [],
      options5: [],
      options6: [],
      options7: [],
      options8: [],
      options9: [],
      options10: [],
      options11: [],

      returnData: [],
      delData: [],
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    // 合并信息是否为空
    mergeIsEmpty() {
      switch (showFlag) {
        case "ais_education":
          if (this.options1.length > 0 && isEmpty(this.input_1)) return true;
          if (this.options2.length > 0 && isEmpty(this.input_2)) return true;
          if (this.options3.length > 0 && isEmpty(this.input_3)) return true;
          if (this.options4.length > 0 && isEmpty(this.input_4)) return true;
          if (this.options5.length > 0 && isEmpty(this.input_5)) return true;
          if (this.options6.length > 0 && isEmpty(this.input_6)) return true;
          break;
        case "ais_job_info":
          if (this.options1.length > 0 && isEmpty(this.input_1)) return true;
          if (this.options2.length > 0 && isEmpty(this.input_2)) return true;
          if (this.options3.length > 0 && isEmpty(this.input_3)) return true;
          if (this.options4.length > 0 && isEmpty(this.input_4)) return true;
          if (this.options5.length > 0 && isEmpty(this.input_5)) return true;
          if (this.options6.length > 0 && isEmpty(this.input_6)) return true;
          if (this.options7.length > 0 && isEmpty(this.input_7)) return true;
          if (this.options8.length > 0 && isEmpty(this.input_8)) return true;
          if (this.options9.length > 0 && isEmpty(this.input_9)) return true;
          if (this.options10.length > 0 && isEmpty(this.input_10)) return true;
          if (this.options11.length > 0 && isEmpty(this.input_11)) return true;
          break;
          break;
        case "ais_journal":
          if (this.options1.length > 0 && isEmpty(this.input_1)) return true;
          if (this.options2.length > 0 && isEmpty(this.input_2)) return true;
          if (this.options3.length > 0 && isEmpty(this.input_3)) return true;
          if (this.options4.length > 0 && isEmpty(this.input_4)) return true;
          if (this.options5.length > 0 && isEmpty(this.input_5)) return true;
          break;
        case "ais_honor":
          if (this.options1.length > 0 && isEmpty(this.input_1)) return true;
          if (this.options2.length > 0 && isEmpty(this.input_2)) return true;
          break;
      }
      return false;
    },
    save() {
      if (this.mergeIsEmpty()) {
        this.$message.error("请选择合并字段数据");
        return;
      }
      this.returnData.forEach((ret) => {
        this.delData.forEach((del) => {
          if (ret.id == del.id) ret.delete_time = new Date().getTime() / 1000;
        });
      });

      var thisInfo = {};
      thisInfo.id = 0;
      thisInfo.delete_time = 0;
      switch (showFlag) {
        case "ais_education":
          thisInfo.education_status = this.input_1;
          thisInfo.location = this.input_2;
          thisInfo.education_school = this.input_3;
          thisInfo.education_programme = this.input_4;
          thisInfo.education_graduation_year = this.input_5;
          thisInfo.education_other = this.input_6;
          if (!StrUtils.isEmpty(thisInfo.location)) {
            var locArray = StrUtils.getLocationArray(thisInfo.location);
            thisInfo.education_nation = locArray[0];
            thisInfo.education_province = locArray[1];
            thisInfo.education_city = locArray[2];
          }
          break;
        case "ais_job_info":
          thisInfo.status = this.input_1;
          thisInfo.location = this.input_2;
          thisInfo.organization = this.input_3;
          thisInfo.unit_property = this.input_4;
          thisInfo.job_type = this.input_5;
          thisInfo.position = this.input_6;
          thisInfo.pay = this.input_7;
          thisInfo.registered_address = this.input_8;
          thisInfo.employees = this.input_9;
          thisInfo.turnover = this.input_10;
          thisInfo.freelance = this.input_11;
          if (!StrUtils.isEmpty(thisInfo.location)) {
            var locArray = StrUtils.getLocationArray(thisInfo.location);
            thisInfo.organization_nation = locArray[0];
            thisInfo.organization_province = locArray[1];
            thisInfo.organization_city = locArray[2];
          }
          break;
        case "ais_journal":
          thisInfo.journal_time = this.input_1;
          thisInfo.content = this.input_2;
          thisInfo.money = this.input_3;
          thisInfo.type = this.input_4;
          thisInfo.remark = this.input_5;
          break;
        case "ais_honor":
          thisInfo.honor_time = this.input_1;
          thisInfo.content = this.input_2;
          break;
      }
      this.returnData.push(thisInfo);
      this.$emit("toSave", showFlag, this.returnData);
      this.changVisible = false;
    },
    //页面初始化时加载的事件
    show(flag, all, selection) {
      this.cleanInput();
      this.changVisible = true;
      showFlag = flag;

      this.returnData = [];
      this.delData = [];
      all.forEach((e) => {
        this.returnData.push(e);
      });
      selection.forEach((e) => {
        this.delData.push(e);
      });
      switch (flag) {
        case "ais_education":
          this.initEducation();
          if (!this.arrayDataIsEqual(this.options1)) {
            this.$message.error("相同深造状态的数据才可以合并");
            this.close();
            return;
          }
          break;
        case "ais_job_info":
          this.initJobInfo();
          if (!this.arrayDataIsEqual(this.options1)) {
            this.$message.error("相同工作状态的数据才可以合并");
            this.close();
            return;
          }
          break;
        case "ais_journal":
          this.initJournal();
          break;
        case "ais_honor":
          this.initHonor();
          break;
      }
    },
    // 清除输入框
    cleanInput() {
      this.changVisible = false;
      this.showUnit1 = false;
      this.showUnit2 = false;
      this.showUnit3 = false;
      this.showUnit4 = false;
      this.showUnit5 = false;
      this.showUnit6 = false;
      this.showUnit7 = false;
      this.showUnit8 = false;
      this.showUnit9 = false;
      this.showUnit10 = false;
      this.showUnit11 = false;

      this.input_1 = "";
      this.input_2 = "";
      this.input_3 = "";
      this.input_4 = "";
      this.input_5 = "";
      this.input_6 = "";
      this.input_7 = "";
      this.input_8 = "";
      this.input_9 = "";
      this.input_10 = "";
      this.input_11 = "";

      this.options1 = [];
      this.options2 = [];
      this.options3 = [];
      this.options4 = [];
      this.options5 = [];
      this.options6 = [];
      this.options7 = [];
      this.options8 = [];
      this.options9 = [];
      this.options10 = [];
      this.options11 = [];
    },
    // 添加深造信息
    initEducation() {
      this.title_1 = "深造状态";
      this.title_2 = "所在地";
      this.title_3 = "院校名称";
      this.title_4 = "院校专业";
      this.title_5 = "毕业年份";
      this.title_6 = "其他";
      switch (this.delData[0].education_status) {
        case "硕士研究生":
        case "博士研究生":
          this.showUnit1 = true;
          this.showUnit2 = true;
          this.showUnit3 = true;
          this.showUnit4 = true;
          this.showUnit5 = true;
          break;
        case "重读本科":
        case "第二学士学位":
          this.showUnit1 = true;
          this.showUnit4 = true;
          break;
        case "其他":
          this.showUnit1 = true;
          this.showUnit6 = true;
          break;
      }
      this.delData.forEach((element) => {
        if (
          !isEmpty(element.education_status) &&
          this.options1.indexOf(element.education_status) < 0
        ) {
          this.options1.push(element.education_status);
        }
        element.location = StrUtils.getEduLocation(element);
        if (
          !isEmpty(element.location) &&
          this.options2.indexOf(element.location) < 0
        ) {
          this.options2.push(element.location);
        }
        if (
          !isEmpty(element.education_school) &&
          this.options3.indexOf(element.education_school) < 0
        ) {
          this.options3.push(element.education_school);
        }
        if (
          !isEmpty(element.education_programme) &&
          this.options4.indexOf(element.education_programme) < 0
        ) {
          this.options4.push(element.education_programme);
        }
        if (
          !isEmpty(element.education_graduation_year) &&
          this.options5.indexOf(element.education_graduation_year) < 0
        ) {
          this.options5.push(element.education_graduation_year);
        }
        if (
          !isEmpty(element.education_other) &&
          this.options6.indexOf(element.education_other) < 0
        ) {
          this.options6.push(element.education_other);
        }
      });
      if (this.arrayDataIsEqual(this.options1)) this.input_1 = this.options1[0];
      if (this.arrayDataIsEqual(this.options2)) this.input_2 = this.options2[0];
      if (this.arrayDataIsEqual(this.options3)) this.input_3 = this.options3[0];
      if (this.arrayDataIsEqual(this.options4)) this.input_4 = this.options4[0];
      if (this.arrayDataIsEqual(this.options5)) this.input_5 = this.options5[0];
      if (this.arrayDataIsEqual(this.options6)) this.input_6 = this.options6[0];
    },
    // 添加工作信息
    initJobInfo() {
      this.title_1 = "工作状态";
      this.title_2 = "所在地";
      this.title_3 = "单位名称";
      this.title_4 = "单位性质";
      this.title_5 = "行业类型";
      this.title_6 = "工作职位";
      this.title_7 = "薪酬范围";
      this.title_8 = "公司注册地";
      this.title_9 = "雇员人数";
      this.title_10 = "年营业额";
      this.title_11 = "从事何种自由职业";
      switch (this.delData[0].status) {
        case "就业":
          this.showUnit1 = true;
          this.showUnit2 = true;
          this.showUnit3 = true;
          this.showUnit4 = true;
          this.showUnit5 = true;
          this.showUnit6 = true;
          this.showUnit7 = true;
          break;
        case "自主创业":
          this.showUnit1 = true;
          this.showUnit2 = true;
          this.showUnit3 = true;
          this.showUnit4 = true;
          this.showUnit5 = true;
          this.showUnit6 = true;
          this.showUnit7 = true;
          this.showUnit8 = true;
          this.showUnit9 = true;
          this.showUnit10 = true;
          break;
        case "自由职业":
          this.showUnit1 = true;
          this.showUnit2 = true;
          this.showUnit5 = true;
          this.showUnit11 = true;
          break;
        case "待业":
        case "深造":
          this.showUnit1 = true;
          break;
      }
      this.delData.forEach((element) => {
        if (
          !isEmpty(element.status) &&
          this.options1.indexOf(element.status) < 0
        ) {
          this.options1.push(element.status);
        }
        element.location = StrUtils.getJobLocation(element);
        if (
          !isEmpty(element.location) &&
          this.options2.indexOf(element.location) < 0
        ) {
          this.options2.push(element.location);
        }
        if (
          !isEmpty(element.organization) &&
          this.options3.indexOf(element.organization) < 0
        ) {
          this.options3.push(element.organization);
        }
        if (
          !isEmpty(element.unit_property) &&
          this.options4.indexOf(element.unit_property) < 0
        ) {
          this.options4.push(element.unit_property);
        }
        if (
          !isEmpty(element.job_type) &&
          this.options5.indexOf(element.job_type) < 0
        ) {
          this.options5.push(element.job_type);
        }
        if (
          !isEmpty(element.position) &&
          this.options6.indexOf(element.position) < 0
        ) {
          this.options6.push(element.position);
        }
        if (!isEmpty(element.pay) && this.options7.indexOf(element.pay) < 0) {
          this.options7.push(element.pay);
        }
        if (
          !isEmpty(element.registered_address) &&
          this.options8.indexOf(element.registered_address) < 0
        ) {
          this.options8.push(element.registered_address);
        }
        if (
          !isEmpty(element.employees) &&
          this.options9.indexOf(element.employees) < 0
        ) {
          this.options9.push(element.employees);
        }
        if (
          !isEmpty(element.turnover) &&
          this.options10.indexOf(element.turnover) < 0
        ) {
          this.options10.push(element.turnover);
        }
        if (
          !isEmpty(element.freelance) &&
          this.options11.indexOf(element.freelance) < 0
        ) {
          this.options11.push(element.freelance);
        }
      });
      if (this.arrayDataIsEqual(this.options1)) this.input_1 = this.options1[0];
      if (this.arrayDataIsEqual(this.options2)) this.input_2 = this.options2[0];
      if (this.arrayDataIsEqual(this.options3)) this.input_3 = this.options3[0];
      if (this.arrayDataIsEqual(this.options4)) this.input_4 = this.options4[0];
      if (this.arrayDataIsEqual(this.options5)) this.input_5 = this.options5[0];
      if (this.arrayDataIsEqual(this.options6)) this.input_6 = this.options6[0];
      if (this.arrayDataIsEqual(this.options7)) this.input_7 = this.options7[0];
      if (this.arrayDataIsEqual(this.options8)) this.input_8 = this.options8[0];
      if (this.arrayDataIsEqual(this.options9)) this.input_9 = this.options9[0];
      if (this.arrayDataIsEqual(this.options10))
        this.input_10 = this.options10[0];
      if (this.arrayDataIsEqual(this.options11))
        this.input_11 = this.options11[0];
    },
    // 添加捐助信息
    initJournal() {
      this.showUnit1 = true;
      this.showUnit2 = true;
      this.showUnit3 = true;
      this.showUnit4 = true;
      this.showUnit5 = true;
      this.title_1 = "捐助时间";
      this.title_2 = "捐助内容";
      this.title_3 = "捐助金额";
      this.title_4 = "捐助类型";
      this.title_5 = "备注";
      this.delData.forEach((element) => {
        if (
          !isEmpty(element.journal_time) &&
          this.options1.indexOf(element.journal_time) < 0
        ) {
          this.options1.push(element.journal_time);
        }
        if (
          !isEmpty(element.content) &&
          this.options2.indexOf(element.content) < 0
        ) {
          this.options2.push(element.content);
        }
        if (
          !isEmpty(element.money) &&
          this.options3.indexOf(element.money) < 0
        ) {
          this.options3.push(element.money);
        }
        if (!isEmpty(element.type) && this.options4.indexOf(element.type) < 0) {
          this.options4.push(element.type);
        }
        if (
          !isEmpty(element.remark) &&
          this.options5.indexOf(element.remark) < 0
        ) {
          this.options5.push(element.remark);
        }
      });
      if (this.arrayDataIsEqual(this.options1)) this.input_1 = this.options1[0];
      if (this.arrayDataIsEqual(this.options2)) this.input_2 = this.options2[0];
      if (this.arrayDataIsEqual(this.options3)) this.input_3 = this.options3[0];
      if (this.arrayDataIsEqual(this.options4)) this.input_4 = this.options4[0];
      if (this.arrayDataIsEqual(this.options5)) this.input_5 = this.options5[0];
    },
    // 添加荣誉信息
    initHonor() {
      this.showUnit1 = true;
      this.showUnit2 = true;
      this.title_1 = "荣誉时间";
      this.title_2 = "荣誉内容";
      this.delData.forEach((element) => {
        if (
          !isEmpty(element.honor_time) &&
          this.options1.indexOf(element.honor_time) < 0
        ) {
          this.options1.push(element.honor_time);
        }
        if (
          !isEmpty(element.content) &&
          this.options2.indexOf(element.content) < 0
        ) {
          this.options2.push(element.content);
        }
      });
      if (this.arrayDataIsEqual(this.options1)) this.input_1 = this.options1[0];
      if (this.arrayDataIsEqual(this.options2)) this.input_2 = this.options2[0];
    },
    // 数组内数据是否全部相同
    arrayDataIsEqual(array) {
      var option;
      for (var element in array) {
        if (isEmpty(option)) option = element;
        if (option != element) {
          return false;
        }
        option = element;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
.input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/selectRepeatDialog.vue